import { Syllabus, SyllabusExternal } from '@/kontent/content-types'

export const getSyllabusTitleWithPublicationYear = (
	syllabus: Syllabus | SyllabusExternal,
	isIncludeSyllabusSuffix = true,
) => {
	let title = syllabus.elements.title.value
	if (isIncludeSyllabusSuffix) {
		title = title + ' Syllabus'
	}
	const publicationYear = syllabus.elements.publication_year?.value
	if (publicationYear) {
		title = `${title} (${publicationYear})`
	}
	return title
}
